// Pages that render from the local task store once it is ready; the rest still read props.
export type LocalPage = "templates" | "lists" | "planned" | "myDay" | "zen" | "sidebar" | "details" | "search";

const DEFAULT_PAGES: readonly LocalPage[] = ["templates", "lists", "planned", "myDay", "zen", "sidebar", "details", "search"];

let enabledPages = new Set<LocalPage>(DEFAULT_PAGES);

export function readsLocally(page: LocalPage): boolean {
  return enabledPages.has(page);
}

export function _setLocalPagesForTests(pages: readonly LocalPage[] = DEFAULT_PAGES): void {
  enabledPages = new Set(pages);
}
